import React from "react";
import {Table} from "antd";
import {columns} from "./operatorsData";
import {useDispatch} from "react-redux";

const TableComp = (props) => {
  const [pagination, setPagination] = React.useState({
    current: 1,
    pageSize: 10,
    pageSizeOptions: [10, 20, 50, 100],
    showSizeChanger: true
  });

  const [filters, setFilters] = React.useState(null);
  const [sorter, setSorter] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  const onChange = (pagination, filters, sorter) => {
    setPagination(pagination);
    setFilters(filters);
    setSorter({ [sorter.field]: sorter.order });
  };

  const dispatch = useDispatch();

  const options = {}

  return (
    <Table
      size="small"
      className="striped-table"
      columns={columns(null, filters, sorter)}
      rowKey={(row) => row.id}
      {...props}
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      scroll={{
        x: true
      }}
    />
  );
}

export default TableComp;
